module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thank-you"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading) ? _c('div', [_c('HeroSlider', {
    attrs: {
      "content": _vm.props
    }
  }), _c('div', {
    staticClass: "thank-youinner"
  }, [_c('div', {
    staticClass: "page-intro"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.intro.title)
    }
  }), _c('div', {
    staticClass: "page-intro_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.intro.text)
    }
  }), _c('div', {
    staticClass: "home_btnn"
  }, [_c('router-link', {
    staticClass: "btn-main page-appt__content-btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Return to Homepage")])], 1)])]), _c('FooterMain')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a5f9884","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 634
// module chunks = 1